import Link from 'next/link';

import { ByZeroExPill } from '@/components/Landing/Utils/ByZeroExPill';

import { fontStyles } from '@/styles/typography';

import { ExternalLink } from '@/ui/Link/ExternalLink';
import { Logo } from '@/ui/Logo/Logo';
import { LogoCup } from '@/ui/Logo/LogoCup';

import { routes } from '@/utils/routes';

export const Footer = () => {
  return (
    <footer className="border-token-gray-300 tablet:py-11 border-t px-4 py-8">
      <div className="tablet:flex-row max-w-[1240px] mx-auto flex w-full flex-col items-center justify-between">
        <div className="text-gray-700 flex items-center">
          <Link href={{ pathname: routes.INDEX }}>
            <div className="hover:text-gray-30 mr-3 flex items-center">
              <LogoCup className="mr-2.5" />
              <Logo height={16} />
            </div>
          </Link>
          <ByZeroExPill className="hover:text-gray-800 mt-1.5 inline-block" />
        </div>
        <ul className="tablet:flex-nowrap tablet:justify-end tablet:gap-0 tablet:gap-x-4 tablet:mt-0 tablet:px-0 mt-8 flex flex-wrap justify-center gap-4 px-8">
          <li>
            <ExternalLink
              className={fontStyles({
                variant: 'BODY_LG',
                class:
                  'text-token-gray-1200 hover:text-token-gray-1400 active:text-token-gray-1600 focus:text-token-gray-1200 focus:outline-token-gray-300 inline-block p-1',
              })}
              href={routes.HELP}
            >
              Help
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              className={fontStyles({
                variant: 'BODY_LG',
                class:
                  'text-token-gray-1200 hover:text-token-gray-1400 active:text-token-gray-1600 focus:text-token-gray-1200 focus:outline-token-gray-300 inline-block p-1',
              })}
              href={routes.BLOG}
            >
              Blog
            </ExternalLink>
          </li>
          <li>
            <span
              className={fontStyles({
                variant: 'BODY_LG',
                class:
                  'text-token-gray-1200 hover:text-token-gray-1400 active:text-token-gray-1600 focus:text-token-gray-1200 focus:outline-token-gray-300 inline-block p-1',
              })}
            >
              <Link href={{ pathname: routes.TERMS }}>Terms</Link>
            </span>
          </li>
          <li>
            <span
              className={fontStyles({
                variant: 'BODY_LG',
                class:
                  'text-token-gray-1200 hover:text-token-gray-1400 active:text-token-gray-1600 focus:text-token-gray-1200 focus:outline-token-gray-300 inline-block p-1',
              })}
            >
              <Link href={{ pathname: routes.PRIVACY }}>Privacy</Link>
            </span>
          </li>
        </ul>
      </div>
    </footer>
  );
};
